<template>
<div class="max-width-4 mx-auto md-px2">
    <div class="px2 md-px0">
    <headline link="/gallery-overview" :headline="gallery.title" />
    </div>
    <!-- active Slide has class VueCarouselActive -->

    <carousel ref="carousel" class="carousel image__wrapper md-mt4 sm-mt3 mt2" :perPage="1" :paginationEnabled="false" :navigationEnabled="true">
        <slide class="" v-for="image in gallery.images" :key="image.imgid">
            <div v-lazyload class="carousel-slide flex">
                <div class="skeleton skeleton-loading col-12"></div>
                <img class="contain image__item mx-auto" :data-url="image.thumbnaillink">
            </div>
        </slide>
    </carousel>
    <div class="flex border-top-gray align-middle py1 justify-end px2">
      <p class=" color-gray mr2">Bild {{galleryLoaded == true ? (this.$refs.carousel.currentPage + 1) : '0'}}  von {{(gallery.images.length)}}</p>
      <a :href="'whatsapp://send?text=' + 'app.nachtschicht-schortens.de%2F%23%2Fgallery%2F' + this.$route.params.galleryid + '%2F' + this.$route.params.picid"><img style="width: 2rem;" src="../assets/whatsapp.png"></a>
    </div>
    <!-- <h2 class="h3 px2 pt3 pb2">Kommentare:</h2> -->

    <div class="col-12 comment-wrapper mb4">
      <comment-form :imgid="activeImg"/>
      <div v-if="comments.length == 0 && commentsLoaded == false" class="pt1">
        <div class="px3 h4 mt3">Lade Kommentare...</div>
        <div class="comment-border mt3"></div>
      </div>
      <div v-if="comments.length == 0 && commentsLoaded == true" class="pt1">
        <div class="px2 h4">Noch keine Kommentare vorhanden. Schreib doch etwas Nettes!</div>
        <div class="comment-border mt3"></div>
      </div>
      <comment v-for="comment in comments" 
        :key="comment.id"
        :username="comment.name"
        :posted_at="comment.created_at"
        :comment="comment.comment"
      />
    </div>
    <!-- <button @click="addHashToLocation(gallery.galleryid + '/test')">Klick</button> -->
</div>
</template>
<script>
import { EventBus } from '../event-bus.js';
import Headline from './Headline.vue';
import Comment from './Comment.vue';
import CommentForm from './CommentForm.vue';

import axios from 'axios';
export default {
  name: "Gallery",
  data() {
    return {
      session: {},
      gallery: {
          galleryid: '',
          title: '',
          thumbnail: 'avocado.jpg',
          images: []
      },
      galleryLoaded: false,
      commentsLoaded: false,
      comments: [
      ]
    };
  },
  components: {
    'headline': Headline,
    'comment': Comment,
    'comment-form': CommentForm
  },
  created() {
    window.scrollTo(0,0);
    EventBus.$on('loginSuccessful', (payload) => {
      this.session = payload.session;
    });
    EventBus.$on('loginSuccessfulSubComponents', (payload) => {
      this.session = payload.session;

      this.loadGallery();
    });

    EventBus.$on('reload_comments', () => {
      this.loadComments();
    })
  },
  mounted(){
    EventBus.$emit('loginCheck', {});
    this.loadGallery();
    console.log('gallery route:')
    console.log(this.$route)
    console.log('gallery params:')
    console.log(this.$route.params)
  },
  computed: {
    activeImg(){
      if(this.galleryLoaded == true){
        const { href } = this.$router.resolve(this.gallery.images[this.$refs.carousel.currentPage].id); 
        window.history.pushState({}, null, href);
        console.log('gallery route updated:')
        console.log(this.$route)
        return this.gallery.images[this.$refs.carousel.currentPage].id
      }else{
        return 'not loaded';
      }
    },
  },
  watch: {
    activeImg(newValue){
      console.log('newValue: ' + newValue)
      if(this.activeImg !== 'not loaded' && this.galleryLoaded == true){
      this.loadComments();
      }
    },
    '$route.params.picid': {
      handler: function(newValue){
        console.log('route param changed')
        console.log(newValue)
              if(newValue !== '0'){
              console.log('picid not 0')
              var pic = this.gallery.images.find(x => x.id === this.$route.params.picid);
              console.log(this.gallery.images.indexOf(pic))
              this.$refs.carousel.currentPage = this.gallery.images.indexOf(pic);
              this.$refs.carousel.offset = this.$refs.carousel.carouselWidth * this.gallery.images.indexOf(pic);
            }
      }
    }
  },
  methods: {
    addHashToLocation(params) {
      // history.pushState(
      //   {},
      //   null,
      //   this.$route.path + '#/gallery/' + this.gallery.galleryid + '/' + encodeURIComponent(params)
      // )
      const { href } = this.$router.resolve(params); window.history.pushState({}, null, href);
    },
    loadGallery(){
        this.gallery.galleryid = this.$route.params.galleryid;
        let that = this;
        console.log('Loading Gallery');
        let url =  'https://bilder.nachtschicht-schortens.de/public-api/get/images/json';
        let data = {};
        data.galleries_id = this.$route.params.galleryid;
        console.log(data.galleries_id);
        axios.post(url, data)
        .then(response => {
            console.log(response.data.data);
            that.gallery.images = response.data.data;
            that.gallery.title = response.data.data[0].category_name; 
            this.galleryLoaded = true;
            if(that.$route.params.picid !== '0'){
              console.log('picid not 0')
              var pic = that.gallery.images.find(x => x.id === that.$route.params.picid);
              console.log(that.gallery.images.indexOf(pic))
              that.$refs.carousel.currentPage = that.gallery.images.indexOf(pic);
              that.$refs.carousel.offset = that.$refs.carousel.carouselWidth * that.gallery.images.indexOf(pic);
            }
            this.loadComments();
            
        })
        .catch(function () {
            //console.log('catch Function of AJAX-Called... userprofileError()');
        });
    },
    loadComments(){
      console.log('Loading Comments');
      this.commentsLoaded = false;
      let url =  'https://bilder.nachtschicht-schortens.de/public-api/get/comments/json';
      let data = {};
      data.images_id = this.activeImg;
      console.log(data.images_id);
      axios.post(url, data)
      .then(response => {
        console.log('comment data: ')
          console.log(response.data.data);
          this.comments = response.data.data.reverse()
          this.commentsLoaded = true;      
      })
      .catch(function () {
          //console.log('catch Function of AJAX-Called... userprofileError()');
      });
    }
  }
}
</script>
<style>

</style>
